import { ExclamationCircleFilled } from '@ant-design/icons';
import { Alert, Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface CloseConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function CloseConfirmationModal({
  open,
  onCancel,
  onConfirm,
}: CloseConfirmationModalProps) {
  const { t } = useTranslation(['ajout_dossier']);

  return (
    <Modal
      open={open}
      centered
      onCancel={onCancel}
      footer={null}
      closable={false}
      className="lg:[&_.ant-modal-content]:mx-32 [&_.ant-modal-body]:!px-10 [&_.ant-modal-body]:!py-9 [&_.ant-modal-body]:!rounded-xl"
    >
      <Alert
        type="warning"
        showIcon
        icon={
          <ExclamationCircleFilled className="text-orange-particuliers-6" />
        }
        message={
          <span className="font-semibold text-gray-800">
            {t('ajout_dossier:close_confirm:title')}
          </span>
        }
        description={
          <span className="text-gray-700">
            {t('ajout_dossier:close_confirm:text')}
          </span>
        }
        className="!rounded-2xl !border-0 !bg-orange-particuliers-1 !px-7 !py-6 [&_.ant-alert-message]:!mb-4 !items-start"
      />

      <div className="mt-8 flex items-center justify-between gap-6">
        <Button
          type="link"
          onClick={onCancel}
          className="text-bleu-hellio font-semibold hover:text-bleu-hellio-600 transition-colors"
        >
          {t('ajout_dossier:close_confirm:cancel_cta')}
        </Button>
        <Button type="primary" shape="round" size="large" onClick={onConfirm}>
          {t('ajout_dossier:close_confirm:confirm_cta')}
        </Button>
      </div>
    </Modal>
  );
}
